import getConfig from "next/config";
import {
  ROUTE_BRAND,
  ROUTE_BRANDS,
  ROUTE_BRANDS_ENG_LETTER,
  ROUTE_WORKING_RULES,
  ROUTE_BRANDS_LETTER,
  ROUTE_ABOUT,
  ROUTE_CART,
  ROUTE_CART_DELIVERY,
  ROUTE_CART_PICKUP,
  ROUTE_EDITORIAL_POLICY,
  ROUTE_CHECKOUT,
  ROUTE_CHECKOUT_FAIL,
  ROUTE_CHECKOUT_SUCCESS,
  ROUTE_GUARANTIES,
  ROUTE_INFORMATION,
  ROUTE_TERM_OF_USE,
  ROUTE_INSTRUCTION,
  ROUTE_MARKETING_POLICY,
  ROUTE_PHARMACY,
  ROUTE_TERMS,
  ROUTE_PRODUCT,
  ROUTE_PROMO_PAGE,
  ROUTE_TEAM,
  ROUTE_TEAM_AUTHOR,
  ROUTE_TEAM_DOCTOR,
  ROUTE_TEAM_STAFF,
  ROUTE_SITE_RULES,
  ROUTE_ZC_PLUS,
  ROUTE_ZC_PLUS_TERMS,
  ROUTE_PROMO_CODE,
} from "constants/routes";

const { publicRuntimeConfig } = getConfig();

export const TRANSITION_FAST = "0.2s ease-out";
export const TRANSITION_EASE_IN_OUT = "0.3s ease-in-out";
export const TRANSITION_EASE_IN_OUT_FAST = "0.2s ease-in-out";

export const BLACK = "#000";
export const BLACK_03 = "#b3b3b3";
export const GRAY_BLACK = "#737373";
export const WHITE = "#FFF";
export const YELLOW = "#FFE600";
export const DARK_YELLOW = "#FFC448";
export const ORANGE = "#FF7126";
export const RED = "#EB5757";
export const PURPLE = "#BF3173";
export const GREEN_NEON = "#43A841";
export const LIGHT_BLUE = "#D1E9FB";
export const LIGHT_BLUE_2 = "#5CC1F3";
export const BLUE = "#007FDB";
export const BLUE_2 = "#0073C6";
export const DARK_BLUE = "#004A80";
export const DEEP_BLUE = "#2334BE";
export const VIOLET = "#6439D0";
export const LIGHT_GRAY = "#EDEDED";
export const DARK_GRAY = "#333333";
export const GRAY = "#E7E7E7";
export const BEIGE = "#EDECE8";
export const PINK = "#ffc6ba";
export const INACTIVE_CARD = "#F7F7F7";
export const TRANSPARENT = "transparent";

export const BORDER_RADIUS_NORMAL = "10px";

export const PRODUCT_PREVIEW_SHADOW_SIZE = "16px";
export const PRODUCT_PREVIEW_SHADOW = `0 3px ${PRODUCT_PREVIEW_SHADOW_SIZE} rgba(0, 0, 0, 0.08)`;
export const PRODUCT_PREVIEW_SHADOW_HOVER = `0px 13px ${PRODUCT_PREVIEW_SHADOW_SIZE} rgba(0, 0, 0, 0.08)`;

export const COL_1 = "8.33333333%";
export const COL_2 = "16.66666667%";
export const COL_3 = "25%";
export const COL_4 = "33.33333333%";
export const COL_5 = "41.66666667%";
export const COL_6 = "50%";
export const COL_7 = "58.33333333%";
export const COL_8 = "66.66666667%";
export const COL_9 = "75%";
export const COL_10 = "83.33333333%";
export const COL_11 = "91.66666667%";
export const COL_12 = "100%";

export const Z_1 = 1;
export const Z_SEARCH_OVERLAY = 30;
export const Z_CATALOG_CONTAINER = 20;
export const Z_MOBILE_CATALOG = 50;
export const Z_MOBILE_CATALOG_LIST = 60;
export const Z_SEARCH_ELEMENTS = 70;
export const Z_NAV_BAR = 80;
export const Z_MOBILE_MENU = 90;
export const Z_DROPDOWN = 100;
export const Z_HEADER_INFO = 110;

export const Z_MODALS = 1000;
export const Z_TOASTS = 2000;
export const Z_TOOLTIPS = 3000;

export const STORAGE_PREFIX = publicRuntimeConfig.STORAGE_PREFIX;
export const COOKIE_PREFIX = publicRuntimeConfig.COOKIE_PREFIX || "cookie_";

/* todo: удалить после полного перехода на новую версию сайта
В куки с названием REGION_COOKIE_NAME_BITRIX хранится только id региона
в отличии от REGION_COOKIE_NAME где хранится весь регион с данными
*/
export const BITRIX_REGION_COOKIE_NAME =
  publicRuntimeConfig.BITRIX_REGION_COOKIE_NAME;
export const BITRIX_LAST_CITY_COOKIE_NAME =
  publicRuntimeConfig.BITRIX_LAST_CITY_COOKIE_NAME;

export const BOTTOM_MOBILE_HEIGHT = "60px";

export const HEADER_MOBILE_HEIGHT = "60px";
export const HEADER_TABLET_HEIGHT = "147px";
export const HEADER_LAPTOP_HEIGHT = "212px";

export const HEADER_MOBILE_HEIGHT_STICKY = "60px";
export const HEADER_TABLET_HEIGHT_STICKY = "100px";
export const HEADER_LAPTOP_HEIGHT_STICKY = "100px";

export const EMAIL_REGEX =
  "(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])";

export const PAGE_NUMBER_LITERAL = "PAGEN_1";
export const PAGE_COUNT_LITERAL = "PAGE_COUNT";

export const NUMBER_PHARMACY = "15 000";
export const NAVIGATION_HOVER_TIMEOUT = 100; //ms

export const DEFAULT_REGION_CODE = "moscowregion";
export const DEFAULT_REGION_NUMBER = "77";

export const QUERIES_FOR_PAGE_INDEX = [PAGE_NUMBER_LITERAL, "region"];

export const REGION_SUPPRESSED_ROUTES = [
  ROUTE_TEAM,
  ROUTE_TEAM_STAFF,
  ROUTE_WORKING_RULES,
  ROUTE_TEAM_DOCTOR,
  ROUTE_TEAM_AUTHOR,
  ROUTE_MARKETING_POLICY,
  ROUTE_INSTRUCTION,
  ROUTE_ABOUT,
  ROUTE_ZC_PLUS,
  ROUTE_ZC_PLUS_TERMS,
  ROUTE_PROMO_PAGE,
  ROUTE_EDITORIAL_POLICY,
  ROUTE_PHARMACY,
  ROUTE_TERMS,
  ROUTE_BRANDS,
  ROUTE_BRANDS_LETTER,
  ROUTE_BRANDS_ENG_LETTER,
  ROUTE_TERM_OF_USE,
  ROUTE_BRAND,
  ROUTE_INFORMATION,
  ROUTE_GUARANTIES,
  ROUTE_CART,
  ROUTE_CART_PICKUP,
  ROUTE_CART_DELIVERY,
  ROUTE_CHECKOUT,
  ROUTE_CHECKOUT_SUCCESS,
  ROUTE_SITE_RULES,
  ROUTE_CHECKOUT_FAIL,
  ROUTE_PRODUCT,
  ROUTE_PROMO_CODE,
];

export const INSTRUCTIONS_TITLES = {
  shortDesc: "Краткое описание",
  indictation: "Показания",
  dosage: "Способ применения и дозировка",
  prescription: "Отпуск из аптеки",
  pharmAction: "Фармакологическое действие",
  contraIndication: "Противопоказания",
  storingCondition: "Условия хранения",
  formulation: "Состав",
  sideEffect: "Побочные действия",
  overDosage: "Передозировка",
  specialInstruction: "Особые указания",
  interaction: "Взаимодействие с другими препаратами",
};

export const INSTRUCTIONS_MEDICATION_TITLES = {
  shortDesc: "Краткое описание",
  indictation: "Показания",
  contraIndication: "Противопоказания",
  specialInstruction: "Особые указания",
  pharmAction: "Фармакологическое действие",
  dosage: "Способ применения и дозировка",
  overDosage: "Передозировка",
  sideEffect: "Побочные действия",
  formulation: "Состав",
};

export const CANCEL_CARD_REQUEST_COOKIE_NAME = `${COOKIE_PREFIX}_cancel_card_request_v1`;

export const AGE_RESTRICTIONS = {
  FROM: 18,
  TO: 90,
};

export const SESSION_UTM_KEY_VENDOR = "utm_yandex_metrica_vendor";

export const IMAGE_SIZE_0_210 = "0_210_";
export const IMAGE_SIZE_60_60 = "60_60_";
export const IMAGE_SIZE_80_40 = "80_40_";
export const IMAGE_SIZE_120_90 = "120_90_";
export const IMAGE_SIZE_120_120 = "120_120_";
export const IMAGE_SIZE_150_200 = "150_200_";
export const IMAGE_SIZE_155_90 = "155_90_";
export const IMAGE_SIZE_200_150 = "200_150_";
export const IMAGE_SIZE_200_200 = "200_200_";
export const IMAGE_SIZE_350_210 = "350_210_";
export const IMAGE_SIZE_375_200 = "375_200_";
export const IMAGE_SIZE_400_280 = "400_280_";
export const IMAGE_SIZE_450_200 = "450_200_";
export const IMAGE_SIZE_600_600 = "600_600_";
export const IMAGE_SIZE_1024_768 = "1024_768_";

type DAY_ENUMS = {
  [key: Entity.PreOrder.DeliveryDateLabel | string]: string;
};

export const DAY_KEY_VALUE: DAY_ENUMS = {
  Today: "Сегодня",
  Tomorrow: "Завтра",
  Monday: "ПН",
  Tuesday: "ВТ",
  Wednesday: "СР",
  Thursday: "ЧТ",
  Friday: "ПТ",
  Saturday: "СБ",
  Sunday: "ВС",
};

export const PRICES = {
  1: "Базовый",
  2: "Протек",
  3: "Мех",
  4: "Истекающий срок",
  5: "Мех80",
  6: "",
  7: "Остаток",
  8: "Товары маркетплейсов других поставщиков",
  9: "Товары маркетплейсов",
  10: "Товары маркетплейсов",
  11: "Товары маркетплейсов",
  12: "Товары маркетплейсов",
  13: "Товары маркетплейсов",
  14: "Истекающий срок",
};

export const PHARMACY_LICENSES = {
  medicine: {
    name: "Л042-01050-61/00590176",
    certificate: null,
    createdAt: "14.10.2020",
  },
  veterinary: {
    name: "Л042-00118-50/00005422",
    certificate: null,
    createdAt: "02.03.2021",
  },
  distanceTrading: {
    name: "ДТ-77-000555",
    certificate:
      "/img/information/license-dostavka/permission-distance-trading.png",
    createdAt: "14.06.2022",
  },
  distanceTradingByPrescription: {
    name: "ДТРПЭП-0000015-М",
    certificate: [
      "/img/information/license-dostavka/license-dostavka-by-prescription-1.png",
      "/img/information/license-dostavka/license-dostavka-by-prescription-2.png",
    ],
    createdAt: "24.05.2023",
  },
};

export const ALL_PROPERTIES_PRODUCT = "ALL_PROPERTIES_PRODUCT";

export const CONTACT_PHONE_NUMBER = "8 (800) 500-92-62";

export const EX_NEW_PRICE_PREFIX = "Цена";
export const EX_NEW_BUTTON_TEXT = "Купить";

export const ACCESS_TOKEN_NAME = "zc_access_token";
export const REFRESH_TOKEN_NAME = "zc_refresh_token";
export const ACCESS_TOKEN_MAX_AGE = 10 * 60;
export const REFRESH_TOKEN_MAX_AGE = 180 * 24 * 60 * 60;
